// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */

import React, { type Node, useCallback } from 'react';
import useFastManipulation from './useFastManipulation';
import styles from './TagCloudPicker.css';

type Props = {|
  options: $ReadOnlyArray<{| +value: string, +label: Node |}>,
  values: $ReadOnlyArray<string>,
  onChange: (string[]) => mixed,
|};

const TagCloudPicker = ({ options, values, onChange }: Props) => {
  const change = useCallback(
    (evt: SyntheticEvent<HTMLInputElement>) => {
      if (evt.currentTarget.checked) {
        onChange([...values, evt.currentTarget.value]);
      } else {
        onChange(values.filter(item => item !== evt.currentTarget.value));
      }
    },
    [values, onChange],
  );

  const fastManipulationProps = useFastManipulation();

  return (
    <div className={styles.tagCloudPicker}>
      {options.map(option => (
        <label key={option.value} {...fastManipulationProps}>
          <input
            value={option.value}
            className={styles.input}
            type="checkbox"
            checked={values.includes(option.value)}
            onChange={change}
          />
          <div className={styles.tag}>{option.label}</div>
        </label>
      ))}
    </div>
  );
};

export default TagCloudPicker;
